import { loadingUser, emptyUser } from './constants'
import State from './types'
import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { RootState } from '../types'

export const state: State = {
  error: false,
  passwordExpired: false,
  currentUser: loadingUser,
  acceptanceUser: emptyUser,
  loginCodeUser: emptyUser,
  resetUsername: '',
}

const namespaced = true

export const security: Module<State, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
}
